import { Repository, createRepository } from '@/repositories/Base/Repository'

class ComplementRepository extends Repository {
    endpoint = 'tuevs/specimens/complements'

    fetchAll (params) {
        if (params && params.mapping){
            delete params.mapping
            return this.$axios.get(`mapping/specimens/complements/table`, { params })
        }

        return super.fetchAll(params)
    }

    put (id, params) {
        return this.$axios.put(`${this.endpoint}/${id}/update`, params)
    }

    fetch (id) {
        return this.$axios.get(`${this.endpoint}/${id}/show`)
    }
}

export default new ComplementRepository()

export const create = createRepository(ComplementRepository)
